import Transfer from './Transfer';

export default Transfer;